export interface IFilters {
  [key: string]: (value: any) => boolean
}

export function filterArrayWithOR<TInput = any>(array: TInput[], filters: IFilters): TInput[] {
  const filterKeys = Object.keys(filters)
  const arrayFiltered = array.filter(item => {
    // validates any (OR) of the filter criteria
    return filterKeys.some(key => {
      if (typeof filters[key] !== 'function') {
        return true
      }
      return filters[key](item[key])
    })
  })
  return arrayFiltered
}

export function searchMissingNumber(arr: number[]) {
  for (let i = 0; i < arr[arr.length - 1]; i++) {
    if (i + 1 !== arr[i]) {
      return i + 1
    }
  }
}
